const BASE = '/admin/';
export const PERMISSIONS = {
  CREATE_THEME: {
    value: 'CREATE_THEME',
    fr: 'Créer thème',
    en: 'Create theme'
  },
  UPDATE_THEME: {
    value: 'UPDATE_THEME',
    fr: 'Modifier thème',
    en: 'Update theme'
  },
  GET_THEME: {
    value: 'GET_THEME',
    fr: 'Afficher thème',
    en: 'Read theme'
  },
  DELETE_THEME: {
    value: 'DELETE_THEME',
    fr: 'Supprimer thème',
    en: 'Delete theme'
  },
  CREATE_ABOUT: {
    value: 'CREATE_ABOUT',
    fr: 'Créer à propos',
    en: 'Create about'
  },
  UPDATE_ABOUT: {
    value: 'UPDATE_ABOUT',
    fr: 'Modifier à propos',
    en: 'Update about'
  },
  GET_ABOUT: {
    value: 'GET_ABOUT',
    fr: 'Afficher à propos',
    en: 'Read about'
  },
  CREATE_ARTICLE: {
    value: 'CREATE_ARTICLE',
    fr: 'Créer article',
    en: 'Create article'
  },
  UPDATE_ARTICLE: {
    value: 'UPDATE_ARTICLE',
    fr: 'Modifier article',
    en: 'Update article'
  },
  GET_ARTICLE: {
    value: 'GET_ARTICLE',
    fr: 'Afficher article',
    en: 'Read article'
  },
  DELETE_ARTICLE: {
    value: 'DELETE_ARTICLE',
    fr: 'Supprimer article',
    en: 'Delete article'
  },
  CREATE_CERTIFICATE: {
    value: 'CREATE_CERTIFICATE',
    fr: 'Créer certificat',
    en: 'Create certificate'
  },
  UPDATE_CERTIFICATE: {
    value: 'UPDATE_CERTIFICATE',
    fr: 'Modifier certificat',
    en: 'Update certificate'
  },
  GET_CERTIFICATE: {
    value: 'GET_CERTIFICATE',
    fr: 'Afficher certificat',
    en: 'Read certificate'
  },
  CREATE_USRAJ: {
    value: 'CREATE_USRAJ',
    fr: 'Créer usraj',
    en: 'Create usraj'
  },
  UPDATE_USRAJ: {
    value: 'UPDATE_USRAJ',
    fr: 'Modifier usraj',
    en: 'Update usraj'
  },
  CREATE_TEMOIGNAGE: {
    value: 'CREATE_TEMOIGNAGE',
    fr: 'Créer témoignage',
    en: 'Create témoignage'
  },
  UPDATE_TEMOIGNAGE: {
    value: 'UPDATE_TEMOIGNAGE',
    fr: 'Modifier témoignage',
    en: 'Update témoignage'
  },
  GET_TEMOIGNAGE: {
    value: 'GET_TEMOIGNAGE',
    fr: 'Afficher témoignage',
    en: 'Read témoignage'
  },
  DELETE_TEMOIGNAGE: {
    value: 'DELETE_TEMOIGNAGE',
    fr: 'Supprimer témoignage',
    en: 'Delete témoignage'
  },
  GET_USRAJ: {
    value: 'GET_USRAJ',
    fr: 'Afficher usraj',
    en: 'Read usraj'
  },
  DELETE_USRAJ: {
    value: 'DELETE_USRAJ',
    fr: 'Supprimer usraj',
    en: 'Delete usraj'
  },
  UPDATE_USRAJ_ADMIN: {
    value: 'UPDATE_USRAJ_ADMIN',
    fr: 'Modifier l\'administrateur de l\'usraj',
    en: 'Update usraj administrator'
  },
  CREATE_DENONCIATION: {
    value: 'CREATE_DENONCIATION',
    fr: 'Créer dénonciation',
    en: 'Create denonciation'
  },
  UPDATE_DENONCIATION: {
    value: 'UPDATE_DENONCIATION',
    fr: 'Modifier dénonciation',
    en: 'Update denonciation'
  },
  GET_DENONCIATION: {
    value: 'GET_DENONCIATION',
    fr: 'Afficher dénonciation',
    en: 'Read denonciation'
  },
  DELETE_DENONCIATION: {
    value: 'DELETE_DENONCIATION',
    fr: 'Supprimer dénonciation',
    en: 'Delete denonciation'
  },
  CREATE_GROUPE: {
    value: 'CREATE_GROUPE',
    fr: 'Créer groupe',
    en: 'Create groupe'
  },
  UPDATE_GROUPE: {
    value: 'UPDATE_GROUPE',
    fr: 'Modifier groupe',
    en: 'Update groupe'
  },
  GET_GROUPE: {
    value: 'GET_GROUPE',
    fr: 'Afficher groupe',
    en: 'Read groupe'
  },
  DELETE_GROUPE: {
    value: 'DELETE_GROUPE',
    fr: 'Supprimer groupe',
    en: 'Delete groupe'
  },
  ADD_ROLE_GROUPE: {
    value: 'ADD_ROLE_GROUPE',
    fr: 'Ajouter rôle au groupe',
    en: 'Add role to group'
  },
  REMOVE_ROLE_GROUPE: {
    value: 'REMOVE_ROLE_GROUPE',
    fr: 'Supprimer rôle du groupe',
    en: 'Remove role from group'
  },
  ADD_USER_GROUPE: {
    value: 'ADD_USER_GROUPE',
    fr: 'Ajouter utilisateur au groupe',
    en: 'Add user to group'
  },
  REMOVE_USER_GROUPE: {
    value: 'REMOVE_USER_GROUPE',
    fr: 'Supprimer utilisateur du groupe',
    en: 'Remove user from group'
  },
  SEND_ONE_SMS: {
    value: 'SEND_ONE_SMS',
    fr: 'Envoyer un sms',
    en: 'Send one sms'
  },
  SEND_GROUP_SMS: {
    value: 'SEND_GROUP_SMS',
    fr: 'Envoyer plusieurs sms',
    en: 'Send many sms'
  },
  CREATE_MISSION: {
    value: 'CREATE_MISSION',
    fr: 'Créer mission',
    en: 'Create mission'
  },
  UPDATE_MISSION: {
    value: 'UPDATE_MISSION',
    fr: 'Modifier mission',
    en: 'Update mission'
  },
  GET_MISSION: {
    value: 'GET_MISSION',
    fr: 'Afficher mission',
    en: 'Read mission'
  },
  DELETE_MISSION: {
    value: 'DELETE_MISSION',
    fr: 'Supprimer mission',
    en: 'Delete mission'
  },
  CREATE_WORK: {
    value: 'CREATE_WORK',
    fr: 'Créer travail',
    en: 'Create work'
  },
  GET_WORK: {
    value: 'GET_WORK',
    fr: 'Afficher travail',
    en: 'Read work'
  },
  DELETE_WORK: {
    value: 'DELETE_WORK',
    fr: 'Supprimer travail',
    en: 'Delete work'
  },
  CREATE_PARAMETER: {
    value: 'CREATE_PARAMETER',
    fr: 'Créer paramètre',
    en: 'Create parameter'
  },
  UPDATE_PARAMETER: {
    value: 'UPDATE_PARAMETER',
    fr: 'Modifier paramètre',
    en: 'Update parameter'
  },
  GET_PARAMETER: {
    value: 'GET_PARAMETER',
    fr: 'Afficher paramètre',
    en: 'Read parameter'
  },
  CREATE_PRODUCT: {
    value: 'CREATE_PRODUCT',
    fr: 'Créer produit',
    en: 'Create product'
  },
  UPDATE_PRODUCT: {
    value: 'UPDATE_PRODUCT',
    fr: 'Modifier produit',
    en: 'Update product'
  },
  GET_PRODUCT: {
    value: 'GET_PRODUCT',
    fr: 'Afficher produit',
    en: 'Read product'
  },
  DELETE_PRODUCT: {
    value: 'DELETE_PRODUCT',
    fr: 'Supprimer produit',
    en: 'Delete product'
  },
  CREATE_PUBLICATION: {
    value: 'CREATE_PUBLICATION',
    fr: 'Créer publication',
    en: 'Create publication'
  },
  UPDATE_PUBLICATION: {
    value: 'UPDATE_PUBLICATION',
    fr: 'Modifier publication',
    en: 'Update publication'
  },
  GET_PUBLICATION: {
    value: 'GET_PUBLICATION',
    fr: 'Afficher publication',
    en: 'Read publication'
  },
  DELETE_PUBLICATION: {
    value: 'DELETE_PUBLICATION',
    fr: 'Supprimer publication',
    en: 'Delete publication'
  },
  CREATE_RAPPORT: {
    value: 'CREATE_RAPPORT',
    fr: 'Créer rapport',
    en: 'Create rapport'
  },
  UPDATE_RAPPORT: {
    value: 'UPDATE_RAPPORT',
    fr: 'Modifier rapport',
    en: 'Update rapport'
  },
  GET_RAPPORT: {
    value: 'GET_RAPPORT',
    fr: 'Afficher rapport',
    en: 'Read rapport'
  },
  DELETE_RAPPORT: {
    value: 'DELETE_RAPPORT',
    fr: 'Supprimer rapport',
    en: 'Delete rapport'
  },
  PERMISSION_ROLE_READ: {
    value: 'PERMISSION_ROLE_READ',
    fr: 'Afficher permission rôle',
    en: 'Read permission role'
  },
  PERMISSION_ROLE_MANAGE_PERMISSIONS: {
    value: 'PERMISSION_ROLE_MANAGE_PERMISSIONS',
    fr: 'Gérer permission rôle',
    en: 'Manage permission role'
  },
  CREATE_SERVICE: {
    value: 'CREATE_SERVICE',
    fr: 'Créer service',
    en: 'Create service'
  },
  UPDATE_SERVICE: {
    value: 'UPDATE_SERVICE',
    fr: 'Modifier service',
    en: 'Update service'
  },
  GET_SERVICE: {
    value: 'GET_SERVICE',
    fr: 'Afficher service',
    en: 'Read service'
  },
  DELETE_SERVICE: {
    value: 'DELETE_SERVICE',
    fr: 'Supprimer service',
    en: 'Delete service'
  },
  SEE_QRCODE: {
    value: 'SEE_QRCODE',
    fr: 'Voir qrcode',
    en: 'See qrcode'
  },
  GET_SLIDER: {
    value: 'GET_SLIDER',
    fr: 'Afficher slider',
    en: 'Read slider'
  },
  UPDATE_SLIDER: {
    value: 'UPDATE_SLIDER',
    fr: 'Modifier slider',
    en: 'Update slider'
  },
  CREATE_SLIDER: {
    value: 'CREATE_SLIDER',
    fr: 'Créer slider',
    en: 'Create slider'
  },
  DELETE_SLIDER: {
    value: 'DELETE_SLIDER',
    fr: 'Supprimer slider',
    en: 'Delete slider'
  },
  CREATE_USER: {
    value: 'CREATE_USER',
    fr: 'Créer utilisateur',
    en: 'Create user'
  },
  CREATE_ADMIN_USER: {
    value: 'CREATE_ADMIN_USER',
    fr: 'Créer un administrateur',
    en: 'Create an administrator'
  },
  CREATE_PREFET_USER: {
    value: 'CREATE_PREFET_USER',
    fr: 'Créer un préfet',
    en: 'Create a prefect'
  },
  CREATE_MAIRE_USER: {
    value: 'CREATE_MAIRE_USER',
    fr: 'Créer un maire',
    en: 'Create a mayor'
  },
  CREATE_CCRP_USER: {
    value: 'CREATE_CCRP_USER',
    fr: 'Créer un ccrp',
    en: 'Create a ccrp'
  },
  CREATE_CC_USER: {
    value: 'CREATE_CC_USER',
    fr: 'Créer un cc',
    en: 'Create a cc'
  },
  CREATE_CP_USER: {
    value: 'CREATE_CP_USER',
    fr: 'Créer un administrateur d\'usraj',
    en: 'Create an administrator of usraj'
  },
  GET_USER: {
    value: 'GET_USER',
    fr: 'Afficher utilisateur',
    en: 'Read user'
  },
  UPDATE_USER: {
    value: 'UPDATE_USER',
    fr: 'Modifier utilisateur',
    en: 'Update user'
  },
  DELETE_USER: {
    value: 'DELETE_USER',
    fr: 'Supprimer utilisateur',
    en: 'Delete user'
  },
  UPDATE_OWNE_USER: {
    value: 'UPDATE_OWNE_USER',
    fr: 'Modifier mon profil',
    en: 'Update my profile'
  },
  SEE_DASHBOARD: {
    value: 'SEE_DASHBOARD',
    fr: 'Voir tableau de bord',
    en: 'See dashboard'
  },
  GET_VALEUR: {
    value: 'GET_VALEUR',
    fr: 'Afficher valeur',
    en: 'Read valeur'
  },
  UPDATE_VALEUR: {
    value: 'UPDATE_VALEUR',
    fr: 'Modifier valeur',
    en: 'Update valeur'
  },
  DELETE_VALEUR: {
    value: 'DELETE_VALEUR',
    fr: 'Supprimer valeur',
    en: 'Delete valeur'
  },
  CREATE_VALEUR: {
    value: 'CREATE_VALEUR',
    fr: 'Créer valeur',
    en: 'Create valeur'
  },
  CREATE_ALERT: {
    value: 'CREATE_ALERT',
    fr: 'Créer alerte',
    en: 'Create alert'
  },
  GET_ALERT: {
    value: 'GET_ALERT',
    fr: 'Afficher alerte',
    en: 'Read alert'
  },
  VALIDATE_ALERT: {
    value: 'VALIDATE_ALERT',
    fr: 'Valider alerte',
    en: 'Validate alert'
  },
  CREATE_ALERT_TYPE: {
    value: 'CREATE_ALERT_TYPE',
    fr: 'Créer type d\'alerte',
    en: 'Create alert type'
  },
  UPDATE_ALERT_TYPE: {
    value: 'UPDATE_ALERT_TYPE',
    fr: 'Modifier type d\'alerte',
    en: 'Update alert type'
  },
  GET_ALERT_TYPE: {
    value: 'GET_ALERT_TYPE',
    fr: 'Afficher type d\'alerte',
    en: 'Read alert type'
  },
  GET_ALERT_TYPE_ADMIN: {
    value: 'GET_ALERT_TYPE_ADMIN',
    fr: 'Afficher type d\'alerte',
    en: 'Read alert type'
  },
  GET_WEATHER: {
    value: 'GET_WEATHER',
    fr: 'Afficher météo',
    en: 'Read weather'
  },
  GET_CHAPTER_ADMIN: {
    value: 'GET_CHAPTER_ADMIN',
    fr: 'Afficher chapitre',
    en: 'Read chapter'
  },
  GET_PARAGRAPH_ADMIN: {
    value: 'GET_PARAGRAPH_ADMIN',
    fr: 'Afficher paragraphe',
    en: 'Read paragraph'
  },
  GET_CHAPTER: {
    value: 'GET_CHAPTER',
    fr: 'Afficher chapitre',
    en: 'Read chapter'
  },
  UPDATE_CHAPTER: {
    value: 'UPDATE_CHAPTER',
    fr: 'Modifier chapitre',
    en: 'Update chapter'
  },
  CREATE_CHAPTER: {
    value: 'CREATE_CHAPTER',
    fr: 'Créer chapitre',
    en: 'Create chapter'
  },
  GET_PARAGRAPH: {
    value: 'GET_PARAGRAPH',
    fr: 'Afficher paragraphe',
    en: 'Read paragraph'
  },
  CREATE_PARAGRAPH: {
    value: 'CREATE_PARAGRAPH',
    fr: 'Créer paragraphe',
    en: 'Create paragraph'
  },
  UPDATE_PARAGRAPH: {
    value: 'UPDATE_PARAGRAPH',
    fr: 'Modifier paragraphe',
    en: 'Update paragraph'
  },
  GET_FORMATION_ADMIN: {
    value: 'GET_FORMATION_ADMIN',
    fr: 'Afficher formation',
    en: 'Read formation'
  },
  GET_FORMATION: {
    value: 'GET_FORMATION',
    fr: 'Afficher formation',
    en: 'Read formation'
  },
  GET_FORMATION_USER: {
    value: 'GET_FORMATION_USER',
    fr: 'Afficher formation',
    en: 'Read formation'
  },
  CREATE_FORMATION: {
    value: 'CREATE_FORMATION',
    fr: 'Créer formation',
    en: 'Create formation'
  },
  UPDATE_FORMATION: {
    value: 'UPDATE_FORMATION',
    fr: 'Modifier formation',
    en: 'Update formation'
  },
  ADD_QUIZZ_FORMATION: {
    value: 'ADD_QUIZZ_FORMATION',
    fr: 'Ajouter quizz formation',
    en: 'Add quizz formation'
  },
  CREATE_CHAPITRE: {
    value: 'CREATE_CHAPITRE',
    fr: 'Créer chapitre',
    en: 'Create chapter'
  },
  CREATE_MODULE: {
    value: 'CREATE_MODULE',
    fr: 'Créer module',
    en: 'Create module'
  },
  UPDATE_MODULE: {
    value: 'UPDATE_MODULE',
    fr: 'Modifier module',
    en: 'Update module'
  },
  DELETE_MODULE: {
    value: 'DELETE_MODULE',
    fr: 'Supprimer module',
    en: 'Delete module'
  },
  GET_MODULE: {
    value: 'GET_MODULE',
    fr: 'Afficher module',
    en: 'Read module'
  },
  CREATE_QUIZ: {
    value: 'CREATE_QUIZ',
    fr: 'Créer quizz',
    en: 'Create quiz'
  },
  UPDATE_QUIZ: {
    value: 'UPDATE_QUIZ',
    fr: 'Modifier quizz',
    en: 'Update quiz'
  },
  GET_QUIZ: {
    value: 'GET_QUIZ',
    fr: 'Afficher quizz',
    en: 'Read quiz'
  },
  CREATE_QUESTION: {
    value: 'CREATE_QUESTION',
    fr: 'Créer question',
    en: 'Create question'
  },
  UPDATE_QUESTION: {
    value: 'UPDATE_QUESTION',
    fr: 'Modifier question',
    en: 'Update question'
  },
  CREATE_CATEGORIE: {
    value: 'CREATE_CATEGORIE',
    fr: 'Créer categorie',
    en: 'Create categorie'
  },
  UPDATE_CATEGORIE: {
    value: 'UPDATE_CATEGORIE',
    fr: 'Modifier categorie',
    en: 'Update categorie'
  },
  GET_PARTENAIRE: {
    value: 'GET_PARTENAIRE',
    fr: 'Afficher partenaire',
    en: 'Read partenaire'
  },
  DELETE_PARTENAIRE: {
    value: 'DELETE_PARTENAIRE',
    fr: 'Supprimer partenaire',
    en: 'Delete partenaire'
  },
  CREATE_PARTENAIRE: {
    value: 'CREATE_PARTENAIRE',
    fr: 'Créer partenaire',
    en: 'Create partenaire'
  },
  GET_CATEGORIE: {
    value: 'GET_CATEGORIE',
    fr: 'Afficher categorie',
    en: 'Read categorie'
  },
  GET_MENU: {
    value: 'GET_MENU',
    fr: 'Afficher menu',
    en: 'Read menu'
  },
  GET_SONDAGE: {
    value: 'GET_SONDAGE',
    fr: 'Afficher sondage',
    en: 'Read sondage'
  },
  CREATE_SONDAGE: {
    value: 'CREATE_SONDAGE',
    fr: 'Créer sondage',
    en: 'Create sondage'
  },
  UPDATE_SONDAGE: {
    value: 'UPDATE_SONDAGE',
    fr: 'Modifier sondage',
    en: 'Update sondage'
  }
};
export const UPDATE = '/update/';
export const Active = '/active/';
export const DASHBOARDSHORT = 'dashboard';
export const PARAMETRESHORT = 'parametre';
export const PARTENAIRESHORT = 'partenaire';
export const DENONCIATIONSHORT = 'denonciation';
export const GROUPESHORT = 'group';
export const USERSHORT = 'user';
export const ARTICLESHORT = 'article';
export const TEMOIGNAGESHORT = 'temoignage';
export const USRAJSHORT = 'usraj';
export const MISSIONSHORT = 'mission';
export const VALEURSHORT = 'valeur';
export const QUIZZSHORT = 'quizz';
export const ELEARNINGSHORT = 'learning';
export const THEMESHORT = 'theme';
export const APROPOSSHORT = 'apropos';
export const CERTIFICATSHORT = 'certificate';
export const SLIDERSSHORT = 'sliders';
export const PROFILESHORT = 'profile';
export const QRCODESHORT = 'qrcode';
export const ALERTCODESHORT = 'alert';
export const WEATHERCODESHORT = 'weather';
export const ALERTTYPECODESHORT = 'risk';
export const CATEGORYCODESHORT = 'category';
export const DASHBOARD = BASE + DASHBOARDSHORT;
export const PROFILE = BASE + PROFILESHORT;
export const QRCODE = BASE + QRCODESHORT;
export const ALERT = BASE + ALERTCODESHORT;
export const WEATHER = BASE + WEATHERCODESHORT;
export const ALERTTYPE = BASE + ALERTTYPECODESHORT;
export const CATEGORY = BASE + CATEGORYCODESHORT;
export const PARAMETRE = BASE + PARAMETRESHORT;
export const PARTENAIRE = BASE + PARTENAIRESHORT;
export const USER = BASE + USERSHORT;
export const DENONCIATION = BASE + DENONCIATIONSHORT;
export const GROUPE = BASE + GROUPESHORT;
export const ARTICLE = BASE + ARTICLESHORT;
export const TEMOIGNAGE = BASE + TEMOIGNAGESHORT;
export const USRAJ = BASE + USRAJSHORT;
export const MISSION = BASE + MISSIONSHORT;
export const VALEUR = BASE + VALEURSHORT;
export const QUIZZ = BASE + QUIZZSHORT;
export const ELEARNING = BASE + ELEARNINGSHORT;
export const THEME = BASE + THEMESHORT;
export const APROPOS = BASE + APROPOSSHORT;
export const CERTIFICAT = BASE + CERTIFICATSHORT;
export const SLIDERS = BASE + SLIDERSSHORT;
export const UNAUTHORIZE = BASE + 'unauthorize';
export const TRADUCTION = { fr: 'fr', en: 'en' };
export const SUPERADMIN = 'SUPERADMIN';
export const ROOT = 'ROOT';
export const ADMIN = 'ADMIN';

export const COMMUNITY_COMMITTEE = 'COMMUNITY_COMMITTEE';
export const CCPR_COMMITTEE = 'CCPR_COMMITTEE';
export const LOCAL_AUTHORITY = 'LOCAL_AUTHORITY';
export const MAIRE = 'MAIRE';
export const compare = (a, b) => {
  if (a.id < b.id)
    return -1;
  if (a.id > b.id)
    return 1;
  return 0;
}
export const constantes = {
  pageable: null,
  last: false,
  totalElements: 0,
  totalPages: 0,
  size: 0,
  number: 0,
  first: false,
  numberOfElements: 0,
  empty: false
};

export const uploadCallback = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      resolve({ data: { link: e.target.result } }); // URL de l'image
    };
    reader.onerror = (e) => reject(e);
    reader.readAsDataURL(file);
  });
};

export function formatAuthor(str, taille) {
  str = str == null ? "..." : str;
  if (str.length > taille) {
    return str.substring(0, taille) + '...';
  } else {
    return str.padEnd(taille, ' ');
  }
};

export function formatDate(dateString) {
  if (dateString == null)
    return "01/01/2023";
  if (dateString.toString().trim().length == 0)
    return "01/01/2023";
  const date = new Date(dateString);
  const day = date.getUTCDate().toString().padStart(2, '0');
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = date.getUTCFullYear();
  return `${day}/${month}/${year}`;
};

export function formatTitle(str, charsPerLine) {
  if (str.length > charsPerLine) {
    return str.substring(0, charsPerLine) + '...';
  } else {
    return str;
  }
};
export const keys = {
  dashboard: {
    id: '1',
    name: DASHBOARDSHORT,
    description: 'dashboardDescription'
  },
  parametre: {
    id: '2',
    name: PARAMETRESHORT,
    description: 'parametreDescription'
  },
  user: {
    id: '3',
    name: USERSHORT,
    description: 'userDescription'
  },
  denonciation: {
    id: '4',
    name: DENONCIATIONSHORT,
    description: 'denonciationDescription'
  },
  group: {
    id: '5',
    name: GROUPESHORT,
    description: 'groupDescription'
  },
  article: {
    id: '6',
    name: ARTICLESHORT,
    description: 'articleDescription'
  },
  temoignage: {
    id: '7',
    name: TEMOIGNAGESHORT,
    description: 'temoignageDescription'
  },
  usraj: {
    id: '8',
    name: USRAJSHORT,
    description: 'usrajDescription'
  },
  mission: {
    id: '9',
    name: MISSIONSHORT,
    description: 'missionDescription'
  },
  valeur: {
    id: '10',
    name: VALEURSHORT,
    description: 'valeurDescription'
  },
  quizz: {
    id: '11',
    name: QUIZZSHORT,
    description: 'quizzDescription'
  },
  elearning: {
    id: '12',
    name: ELEARNINGSHORT,
    description: 'elearningDescription'
  },
  theme: {
    id: '13',
    name: THEMESHORT,
    description: 'themeDescription'
  },
  apropos: {
    id: '14',
    name: APROPOSSHORT,
    description: 'aproposDescription'
  },
  certificate: {
    id: '15',
    name: CERTIFICATSHORT,
    description: 'certificateDescription'
  },
  slides: {
    id: '16',
    name: SLIDERSSHORT,
    description: 'sliderDescription'
  },
  qrcode: {
    id: '17',
    name: QRCODESHORT,
    description: 'qrCodeDescription'
  },
  alert: {
    id: '18',
    name: ALERTCODESHORT,
    description: 'alertDescription'
  },
  weather: {
    id: '19',
    name: WEATHERCODESHORT,
    description: 'weatherDescription'
  },
  risk: {
    id: '20',
    name: ALERTTYPECODESHORT,
    description: 'riskrDescription'
  },
  category: {
    id: '21',
    name: CATEGORYCODESHORT,
    description: 'categoryDescription'
  },
  partenaire: {
    id: '22',
    name: PARTENAIRESHORT,
    description: 'partenaireDescription'
  },
}
